import React, { useState } from 'react';

// Feather icons (UI / génériques)
import {
  FiX,
  FiCheck,
  FiMapPin,
  FiHeart
} from 'react-icons/fi';

// FontAwesome (lieux / métiers)
import {
  FaGraduationCap,
  FaHome,
  FaCoffee,
  FaShoppingBag,
  FaShieldAlt,
} from 'react-icons/fa';

import { MdCarRepair, MdControlCamera, MdGarage, MdSpeed } from "react-icons/md";
const SpecialFiltersModal = ({ isOpen, onClose, onSelectFilter, selectedFilter }) => {
  const [searchTerm, setSearchTerm] = useState('');

  if (!isOpen) return null;

  const filterCategories = [
  /*   {
      id: 'administrative-zones',
      name: 'Zones Administratives (arrondissements)',
      icon: FiMapPin,
      color: 'text-blue-500',
      bgColor: 'bg-blue-50',
      borderColor: 'border-blue-200'
    }, */
    {
      id: 'hospitals',
      name: 'Hôpitaux',
      icon: FiHeart,
      color: 'text-red-500',
      bgColor: 'bg-red-50',
      borderColor: 'border-red-200'
    },
    {
      id: 'schools',
      name: 'Écoles',
      icon: FaGraduationCap,
      color: 'text-green-500',
      bgColor: 'bg-green-50',
      borderColor: 'border-green-200'
    },
    {
      id: 'hotels',
      name: 'Hôtels',
      icon: FaHome,
      color: 'text-purple-500',
      bgColor: 'bg-purple-50',
      borderColor: 'border-purple-200'
    },
    {
      id: 'restaurants',
      name: 'Restaurants',
      icon: FaCoffee,
      color: 'text-amber-500',
      bgColor: 'bg-amber-50',
      borderColor: 'border-amber-200'
    },
    {
      id: 'government',
      name: 'Bâtiments gouvernementaux',
      icon: FaShieldAlt,
      color: 'text-gray-500',
      bgColor: 'bg-gray-50',
      borderColor: 'border-gray-200'
    },
    {
      id: 'commercial',
      name: 'Centres commerciaux',
      icon: FaShoppingBag,
      color: 'text-indigo-500',
      bgColor: 'bg-indigo-50',
      borderColor: 'border-indigo-200'
    },
    {
      id: 'poste-control',
      name: 'Postes de contrôle',
      icon: MdControlCamera,
      color: 'text-blue-500',
      bgColor: 'bg-blue-50',
      borderColor: 'border-blue-200'
    },
    {
      id: 'speed-limit-50',
      name: 'Zones de limitations de vitesse 50km/h',
      icon: MdSpeed,
      color: 'text-green-600',
      bgColor: 'bg-green-50',
      borderColor: 'border-green-200'
    },
    {
      id: 'speed-limit-80',
      name: 'Zones de limitations de vitesse 80km/h',
      icon: MdSpeed,
      color: 'text-yellow-600',
      bgColor: 'bg-yellow-50',
      borderColor: 'border-yellow-200'
    },
    {
      id: 'speed-limit-90',
      name: 'Zones de limitations de vitesse 90km/h',
      icon: MdSpeed,
      color: 'text-orange-600',
      bgColor: 'bg-orange-50',
      borderColor: 'border-orange-200'
    },
    {
      id: 'speed-limit-100',
      name: 'Zones de limitations de vitesse 100km/h',
      icon: MdSpeed,
      color: 'text-red-600',
      bgColor: 'bg-red-50',
      borderColor: 'border-red-200'
    },
    {
      id: 'centre-visite',
      name: 'Centre de visites',
      icon: MdCarRepair,
      color: 'text-blue-500',
      bgColor: 'bg-blue-50',
      borderColor: 'border-blue-200'
    },
    {
      id: 'garage',
      name: 'Garages',
      icon: MdGarage,
      color: 'text-blue-500',
      bgColor: 'bg-blue-50',
      borderColor: 'border-blue-200'
    },
  ];

  const filteredCategories = filterCategories.filter(category =>
    category.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden">
        {/* En-tête du modal */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-xl font-bold text-gray-800">Zones d'interet</h2>
          <button
            onClick={onClose}
            className="p-2 rounded-full hover:bg-gray-100 text-gray-500 hover:text-gray-700 transition-colors"
          >
            <FiX className="w-5 h-5" />
          </button>
        </div>

        {/* Barre de recherche */}
        <div className="p-4 border-b border-gray-200">
          <div className="relative">
            <FiMapPin className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
            <input
              type="text"
              placeholder="Rechercher un type de lieu..."
              className="w-full pl-10 pr-4 py-2.5 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        {/* Contenu du modal */}
        <div className="p-4 overflow-y-auto max-h-[calc(80vh-180px)]">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {filteredCategories.map((category) => {
              const IconComponent = category.icon;
              const isSelected = selectedFilter?.id === category.id;

              return (
                <button
                  key={category.id}
                  onClick={() => onSelectFilter(category)}
                  className={`flex items-center p-4 rounded-xl border transition-all duration-200 text-left ${
                    isSelected
                      ? `${category.borderColor} ${category.bgColor} ring-2 ring-blue-500/30`
                      : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
                  }`}
                >
                  <div className={`p-3 rounded-lg ${category.bgColor} ${category.color} mr-4`}>
                    <IconComponent className="w-6 h-6" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className={`font-medium whitespace-normal break-words leading-snug ${
                      isSelected ? 'text-blue-700' : 'text-gray-800'
                    }`}>
                      {category.name}
                    </h3>
                    <p className="text-sm text-gray-500 mt-1">
                      {isSelected ? 'Sélectionné' : 'Cliquez pour sélectionner'}
                    </p>
                  </div>
                  {isSelected && (
                    <div className="ml-4 p-2 bg-blue-500 rounded-full text-white">
                      <FiCheck className="w-4 h-4" />
                    </div>
                  )}
                </button>
              );
            })}
          </div>

          {filteredCategories.length === 0 && (
            <div className="text-center py-8">
              <FiMapPin className="mx-auto w-12 h-12 text-gray-300 mb-3" />
              <p className="text-gray-500">Aucun filtre trouvé pour "{searchTerm}"</p>
            </div>
          )}
        </div>

        {/* Pied de page */}
        <div className="p-4 border-t border-gray-200 flex justify-end">
          <button
            onClick={onClose}
            className="px-6 py-2.5 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors font-medium"
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
};

export default SpecialFiltersModal;
